import $ from 'jquery';
import BaseView from '../../core/baseView';
import * as eventEmitter from '../../core/eventEmmiter';
import RemotePreloaderView from '../../validation/remotePreloaderView';
import { get as t } from '../../../home24/core/translation';
import * as registry from '../../../home24/core/registry';
export default BaseView.extend({
  validationRules: {
    remoteVat: {
      url: '/default/validator/validatecompanyid',
      type: 'GET',
      data: {
        id: function() {
          return $(
            '.js-company-vat-number input:not(.myaccount-popup-holder .js-company-vat-number input)'
          ).val();
        }
      },
      beforeSend: function() {
        this.preloader =
          this.preloader ||
          new RemotePreloaderView({
            el: $(this).find('.js-company-vat-number input')
          });
        this.preloader.show();
      },
      complete: function() {
        this.preloader.hide();
      }
    }
  },

  initializeModel: function(model) {
    model.set({
      combineValues: Boolean(
        this.$el.find(this.selectors.combinedVatFieldsInput).val()
      ),
      mandatoryRegisterNumber: registry.get('mandatoryRegisterNumber'),
      mandatoryHolderNumber: registry.get('mandatoryHolderNumber'),
      showRegisterNumberField: !this.$el
        .find(this.selectors.registrationNumberWrapper)
        .hasClass(this.selectors.hiddenClass),
      showCompanyHolderField: !this.$el
        .find(this.selectors.companyHolderWrapper)
        .hasClass(this.selectors.hiddenClass)
    });
  },

  triggerChanges: function(model) {
    model.trigger(
      'change:showRegisterNumberField',
      model,
      model.get('showRegisterNumberField')
    );
    model.trigger(
      'change:showCompanyHolderField',
      model,
      model.get('showCompanyHolderField')
    );
  },

  bindEvents: function(model) {
    eventEmitter.on('validationReload', this.addRulesToValidator, this);
    model.on(
      'change:showRegisterNumberField',
      this.onShowRegisterNumberFieldChange,
      this
    );
    model.on(
      'change:showCompanyHolderField',
      this.onShowCompanyHolderField,
      this
    );
  },

  unbindEvents: function(model) {
    eventEmitter.off('validationReload', this.addRulesToValidator, this);
    model.off(
      'change:showRegisterNumberField',
      this.onShowRegisterNumberFieldChange,
      this
    );
    model.off(
      'change:showCompanyHolderField',
      this.onShowCompanyHolderField,
      this
    );
  },

  addRulesToValidator: function() {
    this.$vatNumberField.rules('add', {
      required: true,
      remote: this.validationRules.remoteVat,
      messages: {
        remote: t('ui.input.validation.vat_number.remote.error')
      }
    });
  },

  onShowRegisterNumberFieldChange: function(model, value) {
    if (value) {
      this.$registrationNumber.rules('add', { required: true });
      this.$registrationNumber
        .attr('data-validate', 'true')
        .data('validate', true);
    } else {
      this.$registrationNumber.rules('remove', 'required');
      this.$registrationNumber
        .attr('data-validate', 'false')
        .data('validate', true);
    }
  },

  onShowCompanyHolderField: function(model, value) {
    if (value) {
      this.$companyHolder.rules('add', { required: true });
      this.$companyHolder.attr('data-validate', 'true').data('validate', true);
    } else {
      this.$companyHolder.rules('remove', 'required');
      this.$companyHolder.attr('data-validate', 'false').data('validate', true);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/b2b/businessSpecificBaseView.js
 **/